import { ReactElement, useMemo, useState } from 'react';
import { Tooltip as TippyTooltip } from 'react-tippy';

export interface TooltipItems {
  icon: ReactElement;
  text?: string;
  html?: string | ReactElement;
  includeIconInTooltip?: boolean;
}

export const Tooltip = ({ icon, text, html, includeIconInTooltip }: TooltipItems) => {
  const [open, setOpen] = useState(false);

  const displayedText = useMemo(() => {
    if (html && typeof html === 'string') {
      return (
        <div
          className="tippy-tooltip-content__text"
          dangerouslySetInnerHTML={{ __html: html }}
          aria-label={html}
        />
      );
    }
    return (
      <div
        className="tippy-tooltip-content__text"
        aria-label={text ? text : undefined}
      >
        {html || text}
      </div>
    );
  }, [html, text]);

  return (
    <>
      <TippyTooltip
        position="top-start"
        trigger="manual"
        open={open}
        arrow={true}
        style={{ fontSmooth: 'auto' }}
        html={
          <>
            {includeIconInTooltip && (
              <div
                className="tippy-tooltip-content__icon"
                aria-hidden="true"
              >
                {icon}
              </div>
            )}
            <span
              role="tooltip"
              aria-label={text}
              tabIndex={0}
            >
              {displayedText}
            </span>
          </>
        }
      >
        <span
          role="button"
          tabIndex={0}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          aria-label={typeof html === 'string' ? html : text ? text : undefined}
        >
          {icon}
        </span>
      </TippyTooltip>
    </>
  );
};
